var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6166_47791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8533 8.29358H4.74141C3.43757 8.29358 2.38264 9.36036 2.38264 10.6642L2.37079 24.8879C2.37079 26.1918 3.43757 27.2586 4.74141 27.2586H23.7064C25.0102 27.2586 26.077 26.1918 26.077 24.8879V13.0348C26.077 11.731 25.0102 10.6642 23.7064 10.6642H14.2239L11.8533 8.29358Z",
    fill: "#ADBFDF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip1_6166_47791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.483 4.66833H8.37111C7.06727 4.66833 6.01234 5.73512 6.01234 7.03896L6.00049 21.2627C6.00049 22.5665 7.06727 23.6333 8.37111 23.6333H27.3361C28.6399 23.6333 29.7067 22.5665 29.7067 21.2627V9.40958C29.7067 8.10574 28.6399 7.03896 27.3361 7.03896H17.8536L15.483 4.66833Z",
    fill: "#ADBFDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6166_47791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4475,
    height: 28.4475,
    fill: "white",
    transform: "translate(0 3.55249)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6166_47791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4475,
    height: 28.4475,
    fill: "white",
    transform: "translate(3.55646)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.75aef7e005cc45a0f735ff9b89dc0cd3.svg";
export { ForwardRef as ReactComponent };